import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import axios from 'axios';
import {SnackbarProvider} from "notistack";


axios.defaults.baseURL = 'https://live.pps.paversdev.co.uk/';

ReactDOM.render(<SnackbarProvider maxSnack={5}><App /></SnackbarProvider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
